import { CancellationReasonEnum } from '__generatedTypes__/globalTypes'
import { PlatformSlug } from 'constants/consts'
import { pluralize } from 'utils/pluralize'
import { ALL_REASON_ID } from './constants'
import { CancellationMessageParams, ReasonFilter } from './types'

const getAlreadyTakenLabel = (platformSlug?: PlatformSlug) => {
  if (platformSlug === PlatformSlug.PATBooster) {
    return "I've already taken my PAT"
  }

  if (platformSlug === PlatformSlug.CARSBooster) {
    return "I've already taken my MCAT"
  }

  return "I've already taken my classes"
}

export const getReasonLabel = (reason?: CancellationReasonEnum | null, platformSlug?: PlatformSlug) => {
  if (!reason) {
    return '-'
  }

  const labels: Record<CancellationReasonEnum, string> = {
    [CancellationReasonEnum.TooExpensive]: "It's too expensive",
    [CancellationReasonEnum.NotUsingEnough]: "I'm not using it enough",
    [CancellationReasonEnum.AlreadyTakenClasses]: getAlreadyTakenLabel(platformSlug),
    [CancellationReasonEnum.NotHelpingImprove]: "It's not helping me improve",
    [CancellationReasonEnum.FoundBetterAlternative]: 'I found a better alternative',
    [CancellationReasonEnum.Other]: 'Other',
  }

  return labels[reason]
}

export const getReasonFilters = (platformSlug?: PlatformSlug): ReasonFilter[] => [
  {
    id: ALL_REASON_ID,
    title: 'All reasons',
  },
  ...Object.values(CancellationReasonEnum).map((reason) => ({
    id: reason,
    title: getReasonLabel(reason, platformSlug),
  })),
]

export const getFullName = (firstName?: string | null, lastName?: string | null) =>
  [firstName, lastName].filter(Boolean).join(' ') || '-'

export const getMembershipTypeLabel = (membershipType?: string | null) => membershipType?.trim() || '-'

export const getDurationLabel = (duration?: number | null) => {
  if (duration == null) {
    return '-'
  }

  return `${duration} ${pluralize(duration, 'Day', 'Days')}`
}

export const getMessage = ({
  cancellationReasonDescription,
  cancellationReason,
  platformSlug,
}: CancellationMessageParams) => {
  const message = cancellationReasonDescription?.trim()

  if (!message || message === getReasonLabel(cancellationReason, platformSlug)) {
    return '-'
  }

  return message
}

export const getPercentage = (count: number, total: number) => {
  if (!total) {
    return '0%'
  }

  return `${Math.round((count / total) * 100)}%`
}
